import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/google/session", { session_id: sid })
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true, state: { user: data } });
      })
      .catch((e) => setError(errMsg(e)));
  }, [location.hash, navigate, setUser]);

  if (!error) return <div className="min-h-screen" />;
  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="panel p-8 max-w-md text-center" data-testid="google-auth-error">
        <h2 className="font-display text-2xl mb-3">Sign-in not allowed</h2>
        <p className="text-slate-400 text-sm mb-6">{error}</p>
        <button className="text-amber-400 underline" onClick={() => { window.history.replaceState(null, "", "/login"); navigate("/login", { replace: true }); }} data-testid="back-to-login">Back to login</button>
      </div>
    </div>
  );
}
